import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const ChildrenRetainedInCYRCs = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children retained in CYRCs (%)" />
    </Box>
  );
};
